/**
 * Marketing Kit page (Admin Dashboard tab)
 *
 * History note:
 * The Brand-First Flyer Studio and the Animated CRM Clips section were
 * removed on 2026-03-01 because the Social Assets Library replaces both
 * with a cleaner, platform-aware workflow that Claude AI can drive
 * autonomously via MCP.
 */
import SocialAssetsLibrary from './SocialAssetsLibrary';

export default function MarketingKit() {
  return (
    <div className="space-y-6" data-testid="marketing-kit-page">
      <SocialAssetsLibrary />
    </div>
  );
}
